import { Controller } from "@hotwired/stimulus";
import { CSSPlugin, gsap } from "gsap/all";

gsap.registerPlugin(CSSPlugin);

export default class extends Controller {
  static targets = ["banner"];
  static values = {
    lastUpdatedAt: Number,
  };

  connect() {
    const closedAt = localStorage.getItem("BannerClosedAt");
    if (closedAt && this.lastUpdatedAtValue < closedAt) {
      this.bannerTarget.style.display = "none";
    }
    // Finalement on ne veut plus qu'elle disparraisse au scroll, si on veut
    // qu'elle disparaisse au scroll, décommenter les 2 lignes suivantes
    // this.toggleOnScroll = this.toggleOnScroll.bind(this)
    // window.addEventListener("scroll", this.toggleOnScroll)
  }

  disconnect() {
    window.removeEventListener("scroll", this.toggleOnScroll);
  }

  toggleOnScroll() {
    if (!this.hasBannerTarget) return;

    const banner = this.bannerTarget;

    if (window.scrollY > 0 && banner.style.display !== "none") {
      gsap.to(banner, {
        y: -50,
        opacity: 0,
        duration: 0.5,
        ease: "power2.out",
        onComplete: () => (banner.style.display = "none"),
      });
    } else if (window.scrollY === 0 && banner.style.display === "none") {
      banner.style.display = "block";
      gsap.fromTo(
        banner,
        { y: -50, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.5, ease: "power2.out" }
      );
    }
  }

  close() {
    if (this.hasBannerTarget) {
      this.bannerTarget.style.display = "none";
      localStorage.setItem("BannerClosedAt", Date.now());
    }
  }
}
